<script>
    import { handlers } from 'svelte/legacy';

    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import { SlideEditor } from '../../../SlideEditor.js';
    import { SlideEditor as SlideEditor2 } from '../../../SlideEditor2.js';

    // @ts-ignore
    const tinymce = window.tinymce;
    // @ts-ignore
    const MTRichTextEditor = window.MTRichTextEditor;

    let { mtappVars, item = $bindable() } = $props();

    let setClass = $derived(`form-control mtapp-mf-field-${item.type}`);

    const dispatch = createEventDispatcher();
    function triggerInputChange() {
        dispatch('inputchange');
    }
    function triggerOptionChange(item) {
        if (Array.isArray(item.data)) {
            item.options.forEach((option, index) => {
                item.options[index].checked = item.data.includes(option.data);
            });
        } else {
            item.options.forEach((_, index) => {
                item.options[index].checked = Boolean(item.data);
            });
        }
        dispatch('inputchange');
    }

    // チェックボックスの状態は options[].checked と item.data の2か所にある。バインディングが
    // 作られる前のここで両者を突き合わせておく。onMount では bind:checked の生成より後になり、
    // 値を直しても表示に反映されない。
    //
    // 正本は options[].checked。Vue 版（useVueJs）はこちらしか更新せず、Svelte 版も操作のたびに
    // triggerOptionChange で checked を同期するため、両者が食い違うのは片方しか書かない経路
    // （Vue 版、bind:checked の初期化、フォームの reset）を通ったときだけだから。
    // ただし checked をひとつも持たない設定は item.data 側で初期値を指定している可能性があるので、
    // そのときだけ item.data から checked を作る。
    if (item.type === 'checkbox' && Array.isArray(item.options)) {
        const multiple = item.options.length > 1;
        if (item.options.some((option) => typeof option.checked !== 'undefined')) {
            item.data = multiple
                ? item.options.filter((option) => option.checked).map((option) => option.data)
                : Boolean(item.options[0].checked);
        } else {
            const initial = item.data;
            item.options.forEach((option) => {
                option.checked = multiple ? Array.isArray(initial) && initial.includes(option.data) : Boolean(initial);
            });
            item.data = multiple ? (Array.isArray(initial) ? initial : []) : Boolean(initial);
        }
    }

    onMount(() => {
        if (item.type === 'tinymce') {
            const options = item.options || {};
            const preset = item.preset || '';
            // スライドエディタを初期化

            if (MTRichTextEditor) {
                new SlideEditor2(item.id, options, preset, (content) => {
                    item.data = content;
                    triggerInputChange();
                });
            } else if (tinymce) {
                new SlideEditor(item.id, options, preset, (content) => {
                    item.data = content;
                    triggerInputChange();
                });
            }
        }
    });
</script>

<div data-type={item.type}>
    {#if ['text', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(item.type)}
        <input type="text" class={setClass} id={item.id} bind:value={item.data} oninput={triggerInputChange} />
    {:else if item.type === 'email'}
        <input type="email" class={setClass} id={item.id} bind:value={item.data} oninput={triggerInputChange} />
    {:else if item.type === 'url'}
        <input type="url" class={setClass} id={item.id} bind:value={item.data} oninput={triggerInputChange} />
    {:else if item.type === 'tel'}
        <input type="tel" class={setClass} id={item.id} bind:value={item.data} oninput={triggerInputChange} />
    {:else if item.type === 'password'}
        <input type="password" class={setClass} id={item.id} bind:value={item.data} oninput={triggerInputChange} />
    {:else if item.type === 'number'}
        <input
            type="number"
            class={setClass}
            id={item.id}
            bind:value={item.data}
            oninput={handlers(() => (item.data = String(event.target.value)), triggerInputChange)} />
    {:else if item.type === 'date'}
        <input type="date" class={setClass} id={item.id} bind:value={item.data} oninput={triggerInputChange} />
    {:else if item.type === 'time'}
        <input type="time" class={setClass} id={item.id} bind:value={item.data} oninput={triggerInputChange} />
    {:else if item.type === 'datepicker'}
        <input type="date" class={setClass} id={item.id} bind:value={item.data} oninput={triggerInputChange} />
    {:else if item.type === 'textarea'}
        <textarea class={setClass} id={item.id} rows={item.rows} bind:value={item.data} oninput={triggerInputChange}></textarea>
    {:else if item.type === 'code'}
        <textarea class="form-control font-monospace" id={item.id} rows={item.rows} bind:value={item.data} oninput={triggerInputChange}
        ></textarea>
    {:else if item.type === 'tinymce'}
        <textarea class={setClass} id={item.id} rows={item.rows} bind:value={item.data} oninput={triggerInputChange}></textarea>
        <div id={item.id + '-view'} class="mtapp-slide-editor-viewer">{@html item.data || ''}</div>
        <button id={item.id + '-button'} type="button" class="btn btn-default mt-3">{mtappVars.translate['Edit']}</button>
    {:else if item.type === 'select'}
        <select bind:value={item.data} class="form-select" id={item.id} onchange={triggerInputChange}>
            {#if !item.removeEmptyOption}
                <option value="">{mtappVars.translate['Please select...']}</option>
            {/if}
            {#each item.options as option}
                <option value={option.data}>{option.label}</option>
            {/each}
        </select>
    {:else if item.type === 'checkbox' && item.options.length > 1}
        {#each item.options as option, optionIdx}
            <div class="form-check form-check-inline mtapp-mf-field-checkbox">
                <input
                    type="checkbox"
                    class="form-check-input"
                    value={option.data}
                    id={[item.id, optionIdx].join('-')}
                    bind:group={item.data}
                    onchange={() => triggerOptionChange(item)} />
                <label class="form-check-label" for={[item.id, optionIdx].join('-')}>{option.label}</label>
            </div>
        {/each}
    {:else if item.type === 'checkbox'}
        {#each item.options as option, optionIdx}
            <div class="form-check form-check-inline mtapp-mf-field-checkbox">
                <input
                    type="checkbox"
                    class="form-check-input"
                    value={option.data}
                    id={[item.id, optionIdx].join('-')}
                    bind:checked={item.data}
                    onchange={() => triggerOptionChange(item)} />
                <label class="form-check-label" for={[item.id, optionIdx].join('-')}>{option.label}</label>
            </div>
        {/each}
    {:else if item.type === 'radio'}
        {#each item.options as option, optionIdx}
            <div class="form-check form-check-inline mtapp-mf-field-radio">
                <input
                    type="radio"
                    class="form-check-input"
                    value={option.data}
                    id={[item.id, optionIdx].join('-')}
                    name={item.id}
                    bind:group={item.data}
                    onchange={triggerInputChange} />
                <label class="form-check-label" for={[item.id, optionIdx].join('-')}>{option.label}</label>
            </div>
        {/each}
    {/if}
</div>
